import React, { useContext } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import { Context } from "../Store";
import Loading from "../Loading/Loading";
import SubModel from "../custom-components/SubModel";
import "./Subscriptions.scss";

const SliderSubscriptions = () => {
  const { packagesRes, dir, packagesLoading } = useContext(Context);
  console.log(packagesRes);
  return (
    <Swiper
      dir={dir}
      slidesPerView={3}
      spaceBetween={40}
      slidesPerGroup={1}
      loop={true}
      loopFillGroupWithBlank={false}
      navigation={true}
      modules={[Navigation]}
      breakpoints={{
        0: {
          slidesPerView: 1,
          slidesPerGroup: 1,
        },
        600: {
          slidesPerView: 1,
          slidesPerGroup: 1,
        },
        1000: {
          slidesPerView: 2,
          slidesPerGroup: 1,
        },
        1480: {
          slidesPerView: 3,
          slidesPerGroup: 1,
        },
      }}
    >
      {packagesLoading ? (
        <Loading />
      ) : (
        <>
          {packagesRes?.map((packageData) => (
            <SwiperSlide key={packageData?.id}>
              <SubModel
                title={packageData?.name}
                price={packageData?.priceAfterDiscount}
                duration={packageData?.duration}
                features={packageData?.features}
              />
            </SwiperSlide>
          ))}
        </>
      )}
    </Swiper>
  );
};

export default SliderSubscriptions;
